import Card from 'react-bootstrap/Card';
import './homeTeamCard.css'


const HomeTeamCard = ({ image, title, name }) => {

    return (

        <Card className='projTeam'>
            <div className="projTeamCard">
                <img src={image} alt={name} />
                <div>
                    <Card.Body className='projTeamCardBody'>
                        <Card.Title className='projTeamCardName'>{name}</Card.Title>
                        <Card.Text>
                            {title}
                        </Card.Text>
                    </Card.Body>
                </div>
            </div>
        </Card>


    );
}

export default HomeTeamCard;